import { Routes } from '@angular/router';
import { AUTHENTICATION_ROUTES } from 'src/app/modules/authentication/authentication-routes';

export const FullLayout_Routes: Routes = [
  {
    //Auth
    path: AUTHENTICATION_ROUTES.base.url,
    loadChildren: () => import('../../modules/authentication/authentication.module').then(m => m.AuthenticationModule)
  }
];